




































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action } from 'vuex-class'

import {
  ACCOUNT_PAGE,
  ACCOUNT_SIGN_IN,
  CREATE_TRANSACTION_REQUEST
} from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-constants/helper-constants-1'

import YourAccountHelperComponents2Header from './your-account-helper-components-2-header.vue'
import YourAccountHelperComponents3ResourceList from './your-account-helper-components-3-resource-list.vue'
import App4PageNotFound from '../../../../html-components-type-1-basic/basic-type-1-app/app-4-page-not-found.vue'

const namespace = 'digitalCurrency'

@Component({
  name: 'YourAccountHelperComponents1MainPage',
  components: {
    YourAccountHelperComponents2Header,
    YourAccountHelperComponents3ResourceList,
    App4PageNotFound
  }
})
class YourAccountHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: false }) isUsedForWebComponent?: boolean
  @Prop({ default: false }) isPublicAccountViewing?: boolean

  @Prop({ default: '' }) accountId?: string
  @Prop({ default: false }) showInNav?: boolean

  @Getter('getDigitalCurrencyAccount', { namespace }) getDigitalCurrencyAccount?: any

  @Action('addEventListenerToDigitalCurrencyAccount', { namespace }) addEventListenerToDigitalCurrencyAccount?: any
  @Action('removeEventListenerFromDigitalCurrencyAccount', { namespace }) removeEventListenerFromDigitalCurrencyAccount?: any

  ACCOUNT_PAGE: string = ACCOUNT_PAGE
  ACCOUNT_SIGN_IN: string = ACCOUNT_SIGN_IN
  CREATE_TRANSACTION_REQUEST: string = CREATE_TRANSACTION_REQUEST

  accountEventListenerIdMap: { [accountId: string]: string } = {}

  @Watch('accountId') async updateAccountId (newAccountId: string, oldAccountId: string) {
    if (oldAccountId) {
      await this.stopListeningToAccount(oldAccountId)
    }
    if (newAccountId) {
      await this.startListeningToAccount(newAccountId)
    }
  }

  async mounted () {
    await this.startListeningToAccount(this.accountId!)
  }

  async destroyed () {
    await this.stopListeningToAccount(this.accountId!)
  }

  async startListeningToAccount (accountId: string) {
    if (!accountId || this.accountEventListenerIdMap[accountId]) {
      return
    }
    this.accountEventListenerIdMap[accountId] = await this.addEventListenerToDigitalCurrencyAccount({
      digitalCurrencyAccountId: accountId
    })
  }

  async stopListeningToAccount (accountId: string) {
    if (!accountId) {
      return
    }
    await this.removeEventListenerFromDigitalCurrencyAccount({
      digitalCurrencyAccountId: accountId,
      eventListenerId: this.accountEventListenerIdMap[accountId]
    })

    delete this.accountEventListenerIdMap[accountId]
  }

  signOut () {
    this.emitToggleShowContent({ contentName: ACCOUNT_SIGN_IN, isVisible: true })
    this.deletePreviousContentNameList()
  }

  emitToggleShowContent ({ contentName, isVisible }: { contentName: string, isVisible?: boolean}) {
    this.$emit('toggleShowContent', { contentName, isVisible })
  }

  deletePreviousContentNameList () {
    this.$emit('deletePreviousContentNameList')
  }
}
export default YourAccountHelperComponents1MainPage
